import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import PageTitle from "../components/pageTitle.js";

const AdminInquiryDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [inquiry, setInquiry] = useState(null);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/inquiry/${id}`)
      .then((res) => {
        setInquiry(res.data);
      })
      .catch((err) => console.error("문의 상세 조회 실패:", err));
  }, [id]);

  if (!inquiry) return <div className="p-6">불러오는 중...</div>;

  return (
    <div className="w-full px-4 py-10">
      <div className="max-w-[1100px] mx-auto text-sm">
        {/* 상단 제목 */}

        <h2 className="text-pink-400 text-sm font-bold mb-3">문의/신청 내역</h2>
        <p className="text-[18px] font-semibold mb-3">
          {inquiry.name}님의 문의/신청 내역입니다.
        </p>
        <p className="text-gray-500 text-sm mb-4">
          {inquiry.createdAt?.slice(0, 10)}
        </p>

        {/* 구분선 */}
        <hr className="border-gray-200 mb-2" />

        {/* 내용 라인 */}
        <div className="border-b py-3 flex">
          <div className="w-[100px] font-semibold text-gray-600">이름</div>
          <div className="text-black">{inquiry.name}</div>
        </div>

        <div className="border-b py-3 flex">
          <div className="w-[100px] font-semibold text-gray-600">연락처</div>
          <div className="text-black">{inquiry.phoneNumber}</div>
        </div>

        <div className="border-b py-3 flex">
          <div className="w-[100px] font-semibold text-gray-600">이메일</div>
          <div className="text-black">{inquiry.email}</div>
        </div>

        <div className="border-b py-3 flex items-start">
          <div className="w-[100px] font-semibold text-gray-600 shrink-0">
            장문 입력
          </div>
          <div className="text-black whitespace-pre-wrap break-words">
            {inquiry.content}
          </div>
        </div>

        {/* 버튼 영역 */}
        <div className="flex justify-end gap-2 mt-6">
          {/* <button className="border px-4 py-2 text-sm hover:bg-gray-100">
            일정등록
          </button> */}
          {/* <button className="border px-4 py-2 text-sm hover:bg-gray-100">
            삭제
          </button> */}
          <button
            onClick={() => navigate("/admin/inquiries")}
            className="border px-4 py-2 text-sm hover:bg-gray-100">
            목록보기
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminInquiryDetail;
